var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-feed mt-5"},[_c('div',[_c('v-row',{staticClass:"ma-0"},[_c('h2',[_vm._v("Members Only Content")])]),(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }